
// src/connects/home-groups-nav.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import actions from '../actions'
import { translate } from 'react-i18next'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state)=> {
  const unreadCount = state.notifications.unreadCount

  return {
    isPhone: state.media.isPhone,
    notificationUnreadCount: unreadCount && unreadCount.home,
    chatUnreadCount: state.chatRooms.unreadCount,
    announce: !state.announce.close,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    blinkChatButton: stateProps.firstLogin && (!stateProps.productTour || stateProps.productTour.chatRoom != 'hide'),
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    onLeftIconClick: ()=> dispatch(actions.openSidebar()),
    showNotifications: ()=> dispatch(actions.openRightSidePage('notifications', { group_id: 'home' })),
    showChatRooms: ()=> dispatch(actions.openRightSidePage('chat_rooms', {})),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({ state: { searchDrawer: false }}),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/home-groups-nav.js